import { Component, OnInit, TemplateRef } from '@angular/core';
import { BsModalService } from 'ngx-bootstrap/modal';
import { Calibration_List_Interface, Empty_Calibration_List_Interface } from 'src/app/Interface/Calibration_List_Interface';
import { DeviceBehfa_Interface, Empty_DeviceBehfa_Interface } from 'src/app/Interface/DeviceBehfa_Interface';
import { General_Interface } from 'src/app/Interface/General_Interface';
import { Empty_Kartable_Order_Interface, Kartable_Order_Interface } from 'src/app/Interface/Kartable_Order_Interface';
import { Kartable_Station_Interface } from 'src/app/Interface/Kartable_Station_Interface';
import { AlertifyService } from 'src/app/Service/Alertify.service';
import { CalibrationService } from 'src/app/Service/Calibration/Calibration.service';
import { CalibrationRequestToExitService } from 'src/app/Service/Calibration/CalibrationRequestToExit.service';
import { GeneralService } from 'src/app/Service/General/General.service';
import { KartableService } from 'src/app/Service/Kartable/Kartable.service';
import { LabService } from 'src/app/Service/Lab/Lab.service';
import { LetterRequestCustomerService } from 'src/app/Service/Letter/LetterRequestCustomer.service';
import { NavService } from 'src/app/Service/Nav/Nav.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-KartableInbox',
  templateUrl: './KartableInbox.component.html',
  styleUrls: ['./KartableInbox.component.scss']
})
export class KartableInboxComponent implements OnInit {
  PersianToDayDate: String = ""
  BaseUrl = environment.BaseUrl
  LabUrl = environment.LabUrl
  BaseUrl3 = environment.BaseUrl + "Letterrequestcustomerprint/Mission?id="
  Controller_Data_List: Array<General_Interface> = []
  certificate_user_code: String = ""

  constructor(
    private General_Service: GeneralService,
    private Kartable_Service: KartableService,
    private Calibration_Service: CalibrationService,
    private LetterRequestCustomer_Service: LetterRequestCustomerService,
    private CalibrationRequestToExit_Service: CalibrationRequestToExitService,
    private Alertify_Service: AlertifyService,
    private Nav_Service: NavService,
    private Lab_Service: LabService,
    private modalService: BsModalService
  ) { }





  ngOnInit() {
    this.BaseUrl3 = environment.BaseUrl + "Letterrequestcustomerprint/Mission?id="

    this.Nav_Service.CheckValidPage(1134).subscribe(
      data => {
        this.Read_Today_Date()
      }
      , error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.
      }
    )


  }

  Read_Today_Date() {
    this.General_Service.GetNormalDate().subscribe(
      data => {
        this.PersianToDayDate = data['fulldate']
        this.ReadData_Kartable()
      }
    )
  }

  //#region Kartable

  Filter_Customer_Order: string = ""
  Filter_RecieveCode_Order: string = ""
  Filter_Code2_Order: string = ""
  Filter_Devicename_Order: string = ""
  Filter_Expert_Name_Order: string = ""

  DataList_Kartable_Type: number = 0


  OperationDsc_Kartable: string = ''
  CalibrationDate_Dsc: string = ''
  modalRef_CalibrationDate: any
  modalRef_Kartable: any;

  DataList_Kartable: Array<Kartable_Order_Interface> = []

  DataList_Kartable_total: Array<Kartable_Order_Interface> = []
  DataList_Kartable_wait_erja: Array<Kartable_Order_Interface> = []
  DataList_Kartable_wait_certificate: Array<Kartable_Order_Interface> = []
  DataList_Kartable_wait_certificate_check: Array<Kartable_Order_Interface> = []
  DataList_Kartable_wait_upload: Array<Kartable_Order_Interface> = []


  DataList_Kartable_Selected: Kartable_Order_Interface = Empty_Kartable_Order_Interface()
  DataList_Kartable_Selected_DeviceBehfa: Kartable_Order_Interface = Empty_Kartable_Order_Interface()
  CanModify_Kartable_Selected_DeviceBehfa: boolean = false

  ReadData_Kartable() {
    this.Procssing_Kartable = true
    this.Kartable_Service.GetOrder().subscribe(
      data => {
        this.DataList_Kartable_wait_erja = data['wait_erja']
        this.DataList_Kartable_wait_certificate = data['wait_certificate']
        this.DataList_Kartable_wait_certificate_check = data['wait_certificate_check']
        this.DataList_Kartable_wait_upload = data['wait_upload']

        this.DataList_Kartable = data['total']
        this.DataList_Kartable_total = data['total']


        this.Procssing_Kartable = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }


  wait_erja: number = 0
  wait_certificate: number = 0
  wait_certificate_check: number = 0
  wait_upload: number = 0

  ReadData_Kartable_Count() {
    this.Procssing_Kartable = true
    this.Kartable_Service.GetOrderCount().subscribe(
      data => {
        this.wait_erja = data['wait_erja']
        this.wait_certificate = data['wait_certificate']
        this.wait_certificate_check = data['wait_certificate_check']
        this.wait_upload = data['wait_upload']
        this.Procssing_Kartable = false
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Set__filter_DataList_Kartable(Model: Array<Kartable_Order_Interface>, Type: number) {
    if (Type == this.DataList_Kartable_Type) {
      this.DataList_Kartable = this.DataList_Kartable_total
      this.DataList_Kartable_Type = 0
    }
    else {
      this.DataList_Kartable = Model
      this.DataList_Kartable_Type = Type
    }
    this.page_Kartable = 0
  }

  openModalCalibrationDate(template: TemplateRef<any>, item: Kartable_Order_Interface) {
    this.DataList_Kartable_Selected = item
    this.CalibrationDate_Dsc = ""

    this.modalRef_CalibrationDate = this.modalService.show(template);
  }

  OnSubmitCalibrationDate() {
    this.modalRef_CalibrationDate.hide()
    this.DataList_Kartable_Selected.Processing = true
    this.Lab_Service.SubmitCalibrationDate(this.DataList_Kartable_Selected.calibration_detail_id,
      this.CalibrationDate_Dsc).subscribe(
        data => {
          this.DataList_Kartable_Selected.status = 'انجام کار'
          this.DataList_Kartable_Selected.Processing = false
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
  }

  Procssing_Kartable: boolean = false
  page_Kartable: number = 0;

  openModal_Kartable(template: TemplateRef<any>, Record: Kartable_Order_Interface) {
    this.OperationDsc_Kartable = ''
    this.DataList_Kartable_Selected = Record
    this.modalRef_Kartable = this.modalService.show(template);
  }

  RequestExit() {
    this.modalRef_Kartable.hide()
    this.Procssing_Kartable = true
    this.Lab_Service.RequestExit(this.DataList_Kartable_Selected.id2, this.OperationDsc_Kartable).subscribe(
      data => {
        this.Procssing_Kartable = false
        this.DataList_Kartable_Selected.status = 'بررسی برای ثبت خروج'
        this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  Change_Filter_Order() {
    this.page_Kartable = 0
  }


  OnSet_Calibration_DeviceBehfa(item: Kartable_Order_Interface, canModify: number) {
    this.DataList_Kartable_Selected_DeviceBehfa = item
    this.CanModify_Kartable_Selected_DeviceBehfa = (canModify == 1)
  }

  OnSet_Back_Calibration_DeviceBehfa() {
    this.DataList_Kartable_Selected_DeviceBehfa = Empty_Kartable_Order_Interface()
  }


  SubmitExpertCalibrationDate(item: Kartable_Order_Interface) {

    item.Processing = true
    this.Lab_Service.SubmitExpertCalibrationDate(item.calibration_detail_id).subscribe(
        data => {
          item.status = 'کنترل'
          item.Processing = false
        }, error => {
          // AuthInterceptor owns authentication; feature errors must preserve credentials.

        }
      )
  }

  //#endregion

  //#region Station

  Selected_Calibration_Id_Form: number = -1
  Selected_Calibration_Id_Form_Schedule: number = -1
  Selected_Calibration_Id_Fund: Calibration_List_Interface = Empty_Calibration_List_Interface()
  Selected_Calibration_Id_Certificate: Calibration_List_Interface = Empty_Calibration_List_Interface()
  Selected_Calibration_Id_Evaluate: Calibration_List_Interface = Empty_Calibration_List_Interface()

  OnSet_Back_Calibration_Id_Form(id: number) {
    this.Selected_Calibration_Id_Form = id
  }

  OnSet_Back_Calibration_Id_Form_Schedule(letterSchedule: number) {
    this.Selected_Calibration_Id_Form_Schedule = letterSchedule
    console.log(this.Selected_Calibration_Id_Form_Schedule);
  }

  OnSet_Back_Calibration_Id_Fund(item: Calibration_List_Interface) {
    this.Selected_Calibration_Id_Fund = item
  }

  OnSet_Back_Calibration_Id_Fund_Back(item: any) {
    this.Selected_Calibration_Id_Fund = Empty_Calibration_List_Interface()
  }


  OnSet_Back_Calibration_Id_Evaluate(item: Calibration_List_Interface) {
    this.Selected_Calibration_Id_Evaluate = item
  }

  OnSet_Back_Calibration_Id_Evaluate_Back(item: Calibration_List_Interface) {
    this.Selected_Calibration_Id_Evaluate = Empty_Calibration_List_Interface()
  }


  OnSet_Back_Calibration_Id_Certificate(item: Calibration_List_Interface) {
    this.Selected_Calibration_Id_Certificate = item
  }

  OnSet_Back_Calibration_Id_Certificate_Back() {
    this.Selected_Calibration_Id_Certificate = Empty_Calibration_List_Interface()
  }

  //#endregion

  //#region Upload lab
  Show_Lab_Form: boolean = false
  set_Show_Lab_Form() {
    this.Show_Lab_Form = true
  }

  back_Show_Lab_Form() {
    this.Show_Lab_Form = false
  }


  onFileSelected(event) {
    if(event.target.files.length > 0) 
     {
      this.certificate_user_code= event.target.files[0].name;
      this.certificate_user_code = this.certificate_user_code.replace(".docx","").replace(".doc","")
     }
   }
  //#endregion

  //#region Upload Word

  modalRef_upload: any;
  ProcssingUpload: boolean = false

  Selected_DataList_Calibration: Kartable_Order_Interface = Empty_Kartable_Order_Interface();
  openModal_upload(template: TemplateRef<any>, item: Kartable_Order_Interface) {
    this.modalRef_upload = this.modalService.show(template);
    this.Selected_DataList_Calibration = item
    this.certificate_user_code = item.certificate_user_code
  }

  upload(files) {
    if (files.length === 0)
      return;

    else if (!this.certificate_user_code) {
      this.Alertify_Service.ErrorMessage("کد گواهی نامه را وارد نمائید")
    }
    else {
      const formData = new FormData();

      for (const file of files) {
        formData.append(file.name, file);
      }

      this.ProcssingUpload = true

      this.Calibration_Service.uploadFileCertificate(formData, this.Selected_DataList_Calibration.id2, this.certificate_user_code).subscribe(
        data => {
          this.ProcssingUpload = false
          if (data['id'] == 0) {
            this.Alertify_Service.ErrorMessage(data['filename'])
          }
          else {

            this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")

            this.Selected_DataList_Calibration.filename = data['filename']

          }
        }
      )
    }
  }

  //#endregion

  //#region Controller

  modalRef_Controller: any;

  openModal_Controller(template: TemplateRef<any>, item: Kartable_Order_Interface) {
    this.modalRef_Controller = this.modalService.show(template);
    this.Selected_DataList_Calibration = item
    this.Controller_Data_List = item.controller
  }

  //#endregion

  //#region Customer

  modalRef_Customer: any;
  Selected_DataList_Customer: Kartable_Order_Interface = Empty_Kartable_Order_Interface();
  openModal_Customer(template: TemplateRef<any>, item: Kartable_Order_Interface) {
    this.modalRef_Customer = this.modalService.show(template);
    this.Selected_DataList_Customer = item

  }

  //#endregion

  //#region Request To Exit

  OperationDsc_RequestToExit: string = ''
  modalRef_RequestToExit: any
  DataList_Kartable_Selected_RequestToExit: Kartable_Order_Interface = Empty_Kartable_Order_Interface()

  openModal_RequestToExit(template: TemplateRef<any>, Record: Kartable_Order_Interface) {
    this.OperationDsc_RequestToExit = ''
    this.DataList_Kartable_Selected_RequestToExit = Record
    this.modalRef_RequestToExit = this.modalService.show(template);
  }

  RequestToExit() {
    this.modalRef_RequestToExit.hide()
    this.Procssing_Kartable = true
    this.CalibrationRequestToExit_Service.SubmitRequestToExit(this.DataList_Kartable_Selected_RequestToExit.id2, this.OperationDsc_RequestToExit).subscribe(
      data => {
        this.Procssing_Kartable = false
        if (data['id'] == -1)
          this.Alertify_Service.ErrorMessage("درخواست فعال برای خروج دستگاه وجود دارد")
        else if (data['id'] == -2) {
          this.Alertify_Service.ErrorMessage("گردش کار فعالی برای درخواست خروج دستگاه انتخاب نشده است")
        }
        else if (data['id'] == -3) {
          this.Alertify_Service.ErrorMessage("خطا سیستمی")
        }
        else if (data['id'] == -4) {
          this.Alertify_Service.ErrorMessage("در چارت سازمانی بدون سمت هستید")
        }
        else {
          this.DataList_Kartable_Selected_RequestToExit.hasRequestToExit = 2
          this.Alertify_Service.SuccessMessage("اطلاعات ثبت شد")
        }

      }, error => {
        // AuthInterceptor owns authentication; feature errors must preserve credentials.

      }
    )
  }

  //#endregion


  //#region LetterFile

  modalRef_LetterFile: any;
  LetterFile_Data_List: Array<string> = []
  LetterFile_Data_Code:string = ""
  LetterFile_Data_Tarikh:string = ""
  openModal_LetterFile(template: TemplateRef<any>, item: Kartable_Order_Interface) {
    this.modalRef_LetterFile = this.modalService.show(template);
    this.LetterFile_Data_Code=''
    this.LetterFile_Data_List=[]
    this.LetterRequestCustomer_Service.GetLetterRequestCustomerImage(Number(item.code2)).subscribe(
      data => {
        this.LetterFile_Data_List = data['record']
        this.LetterFile_Data_Code = data['code']
        this.LetterFile_Data_Tarikh = data['bazgasht']
      }
    )
  }

  //#endregion
}
